<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-7">
                <h5 class="mt-2">Cierre Novedades</h5>
              </div>
              <div class="col-sm-5">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item">
                    <router-link to="/Hidrocarburos">Hidrocarburos</router-link>
                  </li>
                  <li class="breadcrumb-item active">Operación</li>
                  <li class="breadcrumb-item active">HSE</li>
                  <li class="breadcrumb-item active">Cierre Novedades</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <div class="card" style="display: inherit">
              <div class="card-header pt-2 pb-2">
                <div class="row">
                  <div class="col-md-11">
                    <h5>Novedades</h5>
                  </div>
                  <div class="col-md-1">
                    <div class="btn-group float-right">
                      <button
                        type="button"
                        class="btn btn-success"
                        data-toggle="modal"
                        data-target="#modal-form-cierre-novedad-export"
                        v-if="$store.getters.can('hidrocarburos.cierreNovedad.exportExcel')"
                      >
                        <i class="far fa-file-excel"></i>
                      </button>
                      <button
                          type="button"
                          class="btn bg-navy"
                          @click="getIndex()"
                        >
                          <i class="fas fa-sync"></i>
                        </button>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="card-body">
                  <h6>Filtros</h6>
                  <div class="row">
                    <div class="form-group col-md-1">
                      <label># Inspección</label>
                      <input
                        type="number"
                        v-model="filtros.id"
                        placeholder="# inspeccion"
                        label="id"
                        class="form-control form-control-sm p-0"
                        @input="getIndex()"
                      />
                    </div>
                    <div class="form-group col-md-1">
                      <label># Viaje</label>
                      <input
                        type="number"
                        v-model="filtros.viaje_id"
                        placeholder="# viaje"
                        label="viaje_id"
                        class="form-control form-control-sm p-0"
                        @input="getIndex()"
                      />
                    </div>
                    <div class="form-group col-md-4">
                      <label>Rango Fechas</label>
                      <div class="row">
                        <div class="col-md-6">
                          <input
                            type="date"
                            class="form-control form-control-sm"
                            v-model="filtros.fecha_inicio"
                            @change="getIndex()"
                          />
                        </div>
                        <div class="col-md-6">
                          <input
                            type="date"
                            class="form-control form-control-sm"
                            v-model="filtros.fecha_fin"
                            @change="getIndex()"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-6">
                      <label>Formato</label>
                      <v-select
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="listasForms.slct_formato_inspeccion"
                        placeholder="Formato Inspección"
                        label="nombre"
                        class="form-control form-control-sm p-0"
                        :options="formatos_inspeccion"
                        :filterable="false"
                        @search="buscarFormatosInspeccion"
                        @input="getIndex()"
                      ></v-select>
                    </div>
                    <div class="form-group col-md-2">
                      <label>Tipo de sitio</label>
                      <select
                        class="form-control form-control-sm"
                        v-model="filtros.sitio_type"
                        @change="getIndex()"
                      >
                        <option value>Seleccione...</option>
                        <option
                          v-for="estado in listasForms.sitio_types"
                          :key="estado.numeracion"
                          :value="estado.numeracion"
                          >{{ estado.descripcion }}</option
                        >
                      </select>
                    </div>
                    <div
                      class="form-group col-md-3"
                      v-if="filtros.sitio_type2 == 'App\\PuntoGestion'"
                    >
                      <label>Punto Gestión</label>
                      <v-select
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="listasForms.slct_puntos_gestion"
                        placeholder="Puntos Gestión"
                        label="nombre"
                        class="form-control form-control-sm p-0"
                        :options="puntos_gestion"
                        :filterable="false"
                        @search="buscarPuntosGestion"
                        @input="getIndex()"
                      ></v-select>
                    </div>
                    <div
                      class="form-group col-md-3"
                      v-else-if="filtros.sitio_type2 == 'App\\Sitio'"
                    >
                      <label>Sitio</label>
                      <v-select
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="listasForms.slct_sitio"
                        placeholder="Sitio"
                        label="nombre"
                        class="form-control form-control-sm p-0"
                        :options="sitios"
                        :filterable="false"
                        @search="buscarSitios"
                        @input="getIndex()"
                      ></v-select>
                    </div>
                    <div class="form-group col-md-3" v-else></div>
                    <div class="form-group col-md-5">
                      <label>Empresa</label>
                      <v-select
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="listasForms.slct_empresa"
                        placeholder="Empresas"
                        label="razon_social"
                        class="form-control form-control-sm p-0"
                        :options="empresas"
                        :filterable="false"
                        @search="buscarEmpresas"
                        @input="getIndex()"
                      ></v-select>
                    </div>
                    <div class="form-group col-md-2">
                      <label>Tipo Combustible</label>
                      <v-select
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="filtros.tipoCombustible"
                        placeholder="Combustible"
                        label="descripcion"
                        class="form-control form-control-sm p-0"
                        :options="listasForms.tiposCombustible"
                        :filterable="false"
                        @input="getIndex()"
                      ></v-select>
                    </div>
                    <div class="form-group col-md-2">
                      <label>Vehículo</label>
                      <v-select
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="listasForms.slct_vehiculo"
                        placeholder="Placa"
                        label="placa"
                        class="form-control form-control-sm p-0"
                        :options="vehiculos"
                        :filterable="false"
                        @search="buscarCabezotes"
                        @input="getIndex()"
                      ></v-select>
                    </div>
                    <div class="form-group col-md-6">
                      <label>Conductor</label>
                      <v-select
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        v-model="listasForms.slct_conductor"
                        placeholder="Conductor"
                        label="nombre"
                        class="form-control form-control-sm p-0"
                        :options="conductores"
                        :filterable="false"
                        @search="buscarConductor"
                        @input="getIndex()"
                      ></v-select>
                    </div>
                    <div class="form-group col-md-2">
                      <label>Estado</label>
                      <select
                        class="form-control form-control-sm"
                        v-model="filtros.estado"
                        @change="getIndex()"
                      >
                        <option value>Seleccione...</option>
                        <option
                          v-for="estado in listasForms.estados"
                          :key="estado.numeracion"
                          :value="estado.numeracion"
                          >{{ estado.descripcion }}</option
                        >
                      </select>
                    </div>
                    <div class="form-group col-md-2">
                      <label>Estado Documento</label>
                      <select
                        class="form-control form-control-sm"
                        v-model="filtros.estado_documento"
                        @change="getIndex()"
                      >
                        <option value>Seleccione...</option>
                        <option
                          v-for="estado in listasForms.estados_documentos"
                          :key="estado.numeracion"
                          :value="estado.numeracion"
                          >{{ estado.descripcion }}</option
                        >
                      </select>
                    </div>
                  </div>
                </div>
                <div class="card-body table-responsive p-0">
                  <table
                    class="table table-bordered table-striped table-hover text-nowrap table-sm"
                  >
                    <thead class="thead">
                      <tr>
                        <th># Insp.</th>
                        <th>Viaje</th>
                        <th>Fecha</th>
                        <th>Novedades</th>
                        <th>Formato</th>
                        <th>Tipo de sitio</th>
                        <th>
                          {{
                            filtros.sitio_type2 == "App\\PuntoGestion"
                              ? "Punto Gestión"
                              : filtros.sitio_type2 == "App\\Sitio"
                              ? "Sitio"
                              : "Sitio/Punto Gestión"
                          }}
                        </th>
                        <th>Empresa</th>
                        <th>Vehículo</th>
                        <th>Conductor</th>
                        <th>Estado</th>
                        <th>Est. Doc</th>
                        <th
                          v-if="
                            $store.getters.can(
                              'hidrocarburos.cierreNovedad.create'
                            )
                          "
                        >
                          Acción
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="inspeccion in inspecciones.data"
                        :key="inspeccion.id"
                      >
                        <td>{{ inspeccion.id }}</td>
                        <td class="text-center">
                          {{
                            inspeccion.viaje_id ? inspeccion.viaje_id : "Preop"
                          }}
                        </td>
                        <td>{{ inspeccion.fecha_inicio }}</td>
                        <td class="text-center">
                          <span
                            class="badge"
                            :class="
                              inspeccion.cierres_novedades_inspecciones
                                .length == 0
                                ? 'bg-pink'
                                : inspeccion.cierres_novedades_inspecciones
                                    .length ==
                                  inspeccion.detalles_inspecciones.length
                                ? 'bg-success'
                                : 'bg-warning'
                            "
                          >
                            {{
                              inspeccion.cierres_novedades_inspecciones.length
                            }}
                            / {{ inspeccion.detalles_inspecciones.length }}
                          </span>
                        </td>
                        <td>
                          {{
                            inspeccion.formato_inspeccion
                              ? inspeccion.formato_inspeccion.nombre
                              : ""
                          }}
                        </td>
                        <td>
                          {{
                            inspeccion.sitio_type == "App\\Sitio"
                              ? "Sitio"
                              : "Punto Gestion"
                          }}
                        </td>
                        <td>
                          {{ inspeccion.sitio ? inspeccion.sitio.nombre : "" }}
                        </td>
                        <td class="text-wrap">
                          {{
                            inspeccion.empresa
                              ? inspeccion.empresa.razon_social
                              : ""
                          }}
                        </td>
                        <td class="text-center">
                          {{
                            inspeccion.vehiculo ? inspeccion.vehiculo.placa : ""
                          }}
                          <div>
                            <span
                              v-if="inspeccion.vehiculo != null"
                              class="badge ml-1 mr-1"
                              :class="
                                inspeccion.vehiculo.tipo_combustible == 1
                                  ? 'badge-warning'
                                  : 'badge-info'
                              "
                            >
                              {{ inspeccion.vehiculo.nCombustible }}
                            </span>
                          </div>
                        </td>
                        <td>
                          {{
                            inspeccion.conductor
                              ? `${inspeccion.conductor.nombres} ${inspeccion.conductor.apellidos}`
                              : ""
                          }}
                        </td>
                        <td class="text-center">
                          <span
                            class="badge"
                            :class="[
                              inspeccion.estado == 1
                                ? 'badge-secondary'
                                : inspeccion.estado == 2
                                ? 'badge-success'
                                : inspeccion.estado == 3
                                ? 'badge-success'
                                : inspeccion.estado == 4
                                ? 'badge-danger'
                                : inspeccion.estado == 5
                                ? 'bg-olive'
                                : '',
                            ]"
                          >
                            {{ inspeccion.nEstado }}
                          </span>
                        </td>
                        <td class="text-center">
                          <span
                            class="badge"
                            :class="[
                              inspeccion.estado_documento == 1
                                ? 'badge-warning'
                                : 'badge-success',
                            ]"
                          >
                            {{ inspeccion.nEstadoDocumento }}
                          </span>
                        </td>
                        <td
                          v-if="
                            $store.getters.can(
                              'hidrocarburos.cierreNovedad.create'
                            )
                          "
                          class="text-right"
                        >
                          <div class="btn-group float-right">
                            <button
                              type="button"
                              class="btn btn-sm bg-navy"
                              data-toggle="modal"
                              data-target="#modal-form-cierre-novedad"
                              @click="
                                $refs.CierreNovedadForm.getIndex(inspeccion.id)
                              "
                            >
                              <i class="fas fa-edit"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="card-footer">
                  <div class="float-left" v-if="inspecciones.total">
                    <p>
                      Mostrando del
                      <b>{{ inspecciones.from }}</b> al
                      <b>{{ inspecciones.to }}</b> de un total:
                      <b>{{ inspecciones.total }}</b> Registros
                    </p>
                  </div>
                  <div class="float-left" v-else>
                    <p>
                      <span class="badge badge-danger"
                        >No hay registros para mostrar</span
                      >
                    </p>
                  </div>
                  <pagination
                    :data="inspecciones"
                    @pagination-change-page="getIndex"
                    :limit="5"
                    class="float-right"
                  ></pagination>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <CierreNovedadForm ref="CierreNovedadForm"></CierreNovedadForm>
    <CierreNovedadExport ref="CierreNovedadExport" />
  </div>
</template>

<script>
import Loading from "../../../../components/Loading";
import axios from "axios";
import pagination from "laravel-vue-pagination";
import vSelect from "vue-select";
import CierreNovedadForm from "./CierreNovedadForm.vue"
import CierreNovedadExport from "./CierreNovedadExport.vue"

export default {
  name: "CierreNovedadIndex",
  components: {
    Loading,
    pagination,
    vSelect,
    CierreNovedadForm,
    CierreNovedadExport,
  },

  data() {
    return {
      cargando: false,
      inspecciones: {},
      filtros: {
        id: null,
        viaje_id: null,
        fecha_inicio: null,
        fecha_fin: null,
        formato_inspeccion_id: null,
        sitio_type: null,
        sitio_type2: null,
        empresa_id: null,
        tipoCombustible: null,
        vehiculo_id: null,
        conductor_id: null,
        estado: null,
        estado_documento: null,
      },
      listasForms: {
        slct_formato_inspeccion: [],
        slct_puntos_gestion: [],
        slct_sitio: [],
        slct_empresa: [],
        tiposCombustible: [],
        slct_vehiculo: [],
        slct_conductor: [],
        estados: [],
        estados_documentos: [],
        sitio_types: [],
      },
      formatos_inspeccion: [],
      puntos_gestion: [],
      sitios: [],
      empresas: [],
      vehiculos: [],
      conductores: [],
    };
  },
  methods: {
    getIndex(page = 1) {
      let me = this;
      me.cargando = true;
      me.filtros.sitio_id = null;
      if (me.filtros.sitio_type) {
        if (me.filtros.sitio_type == 1) {
          me.filtros.sitio_type2 = "App\\Sitio";
          me.filtros.sitio_id = null;
          me.listasForms.slct_puntos_gestion = null;
          if (me.listasForms.slct_sitio) {
            me.filtros.sitio_id = me.listasForms.slct_sitio.id;
          }
        } else {
          this.filtros.sitio_type2 = "App\\PuntoGestion";
          this.listasForms.slct_sitio = null;
          if (this.listasForms.slct_puntos_gestion) {
            this.filtros.sitio_id = this.listasForms.slct_puntos_gestion.id;
          }
        }
      } else {
        me.filtros.sitio_type2 = null;
        me.listasForms.slct_puntos_gestion = null;
        me.listasForms.slct_sitio = null;
      }

      me.filtros.formato_inspeccion_id = me.listasForms.slct_formato_inspeccion
        ? me.listasForms.slct_formato_inspeccion.id
        : null;
      me.filtros.empresa_id = me.listasForms.slct_empresa
        ? me.listasForms.slct_empresa.id
        : null;
      me.filtros.tipo_combustible = me.filtros.tipoCombustible
        ? me.filtros.tipoCombustible.numeracion
        : null;
      me.filtros.vehiculo_id = me.listasForms.slct_vehiculo
        ? me.listasForms.slct_vehiculo.id
        : null;
      me.filtros.conductor_id = me.listasForms.slct_conductor
        ? me.listasForms.slct_conductor.id
        : null;

      // Se valida que la fecha de finalización no sea menor que la fecha de inicio
      if (me.filtros.fecha_inicio && me.filtros.fecha_fin) {
        me.validaFechas();
        me.cargando = false;
      }

      axios
        .get("/api/hidrocarburos/cierreNovedades?page=" + page, {
          params: me.filtros,
        })
        .then((response) => {
          me.cargando = false;
          me.inspecciones = response.data;
        })
        .catch(function(error) {
          me.cargando = false;
          me.$swal({
            icon: "error",
            title: "Ocurrió un error: " + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    validaFechas() {
      const fecha_menor = new Date(this.filtros.fecha_inicio);
      const fecha_mayor = new Date(this.filtros.fecha_fin);
      // Se valida que la fecha inicial sea menor que la fecha final
      if (fecha_menor > fecha_mayor) {
        this.filtros.fecha_fin = null;
        this.$swal({
          icon: "error",
          title: `La fecha inicio no puede ser mayor a la fecha fin...`,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      }
    },

    buscarPuntosGestion(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "api/admin/puntos_gestion/lista?punto_gestion=" + search;
        axios
          .get(url)
          .then(function(response) {
            let respuesta = response.data;
            me.puntos_gestion = respuesta;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarSitios(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "api/admin/sitios/lista?sitio=" + search;
        axios
          .get(url)
          .then(function(response) {
            let respuesta = response.data;
            me.sitios = respuesta;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarFormatosInspeccion(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url =
          "api/admin/formatosInspeccion/lista?formato_inspeccion=" + search;
        axios
          .get(url)
          .then(function(response) {
            let respuesta = response.data;
            me.formatos_inspeccion = respuesta;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarEmpresas(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "api/admin/empresas/lista?razon=" + search;
        axios
          .get(url)
          .then(function(response) {
            let respuesta = response.data;
            me.empresas = respuesta;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrió un error - " + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarCabezotes(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "api/admin/vehiculos/lista?placa=" + search;
        axios
          .get(url)
          .then(function(response) {
            me.vehiculos = response.data;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrió un error - " + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarConductor(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "api/admin/conductores/lista?nombre=" + search;
        axios
          .get(url)
          .then(function(response) {
            me.conductores = response.data;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrió un error - " + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    getTiposCombustibles() {
      axios.get("/api/lista/24").then((response) => {
        this.listasForms.tiposCombustible = response.data;
      });
    },

    getEstados() {
      axios.get("/api/lista/38").then((response) => {
        this.listasForms.estados = response.data;
      });
    },

    getEstadosDocumentos() {
      axios.get("/api/lista/28").then((response) => {
        this.listasForms.estados_documentos = response.data;
      });
    },

    //lista sitio type
    getSitioType() {
      // sitio 1, punto gestion 2
      axios.get("/api/lista/25").then((response) => {
        this.listasForms.sitio_types = response.data;
      });
    },
  },
  mounted() {
    this.getIndex();
    this.getEstados();
    this.getTiposCombustibles();
    this.getSitioType();
    this.getEstadosDocumentos();
  },
};
</script>
